module.exports = __webpack_public_path__ + "static/media/people-blue.4c0c077e.png";